import classNames from 'classnames'
import { BigNumber } from 'ethers'
import { formatUnits } from 'ethers/lib/utils'

import { AboutLockInfo } from '~/components/AboutLockInfo'
import { renderAmount } from '~/lib/helpers'

import { useLockNewDetails } from './useLockNewDetails'

import styles from './Details.pcss'

interface Props {
	amount: BigNumber
	className?: string
	duration: number
}

export function Details({ amount, className, duration }: Props) {
	const { veSISAmount, lockDuration, apr, weeklyRewards, totalRewards } =
		useLockNewDetails(amount, duration)

	return (
		<div className={classNames(styles.container, className)}>
			<div className={styles.label}>LOCK DETAILS</div>
			<div className={styles.content}>
				<AboutLockInfo
					label="veSIS Amount"
					postfix="veSIS"
					value={veSISAmount}
				/>
				<AboutLockInfo
					digits={2}
					label="Lock Duration"
					postfix="Year"
					value={lockDuration}
					invertPlaceholder
				/>
				<AboutLockInfo
					digits={2}
					label="Est. APR"
					value={apr}
					percent
				/>
				<AboutLockInfo
					hint="This is an estimated value. It is calculated based on the total number of SIS tokens locked at the time of calculation and the amount of rewards allocated weekly. "
					label="Est. Weekly Rewards"
					postfix="SIS"
					value={weeklyRewards}
					invertPlaceholder
				/>
				<AboutLockInfo
					hint="This is an estimated value. It is calculated based on the total number of SIS tokens locked at the time of calculation and the amount of rewards allocated weekly. "
					label="Est. Total Rewards"
					value={totalRewards}
					postfix="SIS"
				/>
			</div>
		</div>
	)
}
